import { useRouter } from 'react-resource-router';

import { fg } from '@atlaskit/platform-feature-flags/fg';

import { BENCHMARK_ROUTE_NAME } from '../../../routes';

/**
 * Whether the nav bar offers "Send feedback" on the current route.
 *
 * Withheld on the benchmark page while that experience is still being built.
 * Every surface that renders the action has to ask, because the three of them
 * are reachable at different viewport widths: the inline button in the
 * right-hand cluster, the item in the collapsed hamburger, and the item in the
 * avatar dropdown. Leaving any one of them out would put the action back on the
 * page at some window size.
 *
 * Gated as well as route-scoped. `/benchmark` redirects home when the gate is
 * off, but it is still the matched route while that redirect renders, so
 * without the gate the bar would blink its feedback action away for visitors
 * who cannot reach the page at all.
 */
export const useIsFeedbackOffered = (): boolean => {
	const [{ route }] = useRouter();

	if (route?.name !== BENCHMARK_ROUTE_NAME) {
		return true;
	}

	return !fg('graphyte-twg-cloud-benchmark');
};
